import { TwoDimensionalImage } from 'apps/two-dimensional-image/index';
import { TwoDimensionalVideo } from 'apps/two-dimensional-video/index';

export {
	TwoDimensionalImage,
	TwoDimensionalVideo,
};
